import * as Sentry from "@sentry/react"
import { MutationCache, QueryCache, QueryClient } from "@tanstack/react-query"
import { errorCode } from "api/AxiosProvider/errorCode"
import { isAxiosError } from "axios"

const ReactQueryProvider = {
  onError: (error: unknown) => {
    Sentry.captureException(error)
    if (isAxiosError(error)) {
      if (error.response) {
        const {
          data: { code },
          status,
        } = error.response || {}

        // 🎯 跳過已經被 Axios interceptor 處理的 401 錯誤
        // 如果是一般 API 的 401(access token 過期),interceptor 會自動 refresh 並重試
        // 只有當 refresh 本身失敗時,才會帶有 _isAuthFailure 標記
        if (status === 401 && !(error.response as any)._isAuthFailure) {
          // 這是「可恢復的 401」,已經在 interceptor 中處理了
          // 不顯示 toast,讓用戶無感
          return
        }

        if (status && code && errorCode[status]) {
          const execute = errorCode[status]
          if (execute instanceof Function) {
            execute()
          } else {
            execute[code] && execute[code]()
          }
        }
      }
    }
  },
}

const queryClient = new QueryClient({
  queryCache: new QueryCache(ReactQueryProvider),
  mutationCache: new MutationCache(ReactQueryProvider),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: false,
    },
  },
})

export default queryClient
